module.exports = __webpack_public_path__ + "static/media/8b53e93c-d6a4-445b-90ed-658a486c5399_1.d698e976d588ee4611260a31ceed9236.06533c6d.png";